import React from "react";
import { MapPin, Linkedin, CalendarClock } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Reveal, Kicker } from "../components/Reveal";
import { ContactForm } from "../components/ContactForm";
import { CALENDLY_URL } from "../data/content";

const Contact = () => (
  <div data-testid="contact-page">
    <PageHero
      kicker="Contact Us"
      lines={[<span key="a">Let's discuss</span>, <span key="b">your <em className="italic text-[#3E9BDC]">needs.</em></span>]}
      intro="Please fill out the contact form and a member of our team will contact you to discuss your needs."
    />

    <section className="bg-[#A9CFE2] py-20 md:py-28" data-testid="contact-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <Reveal className="lg:col-span-5">
          <Kicker>American Elm Advisors</Kicker>
          <h2 className="mt-5 font-serif font-bold text-3xl sm:text-4xl text-[#0A2B3D] tracking-tight leading-[1.15]">
            Portsmouth, New Hampshire
          </h2>
          <div className="mt-8 space-y-5 text-[#0A2B3D]">
            <p className="flex items-start gap-3" data-testid="contact-address">
              <MapPin size={18} className="mt-1 shrink-0 text-[#0A2B3D]/70" />
              <span>104 Congress Street, Suite 404<br />Portsmouth, NH 03801</span>
            </p>
            <p className="flex items-center gap-3">
              <Linkedin size={18} className="shrink-0 text-[#0A2B3D]/70" />
              <a href="https://www.linkedin.com/company/americanelm/" target="_blank" rel="noreferrer" data-testid="contact-linkedin-link" className="hover:underline underline-offset-4">
                Follow us on LinkedIn
              </a>
            </p>
          </div>
          <div className="mt-10 p-6 bg-white/60 border border-[#0A2B3D]/15" data-testid="contact-practices-note">
            <p className="text-sm text-[#0A2B3D]/80 leading-relaxed">
              Inquiring about a specific practice? Select it in the form — Compliance Consulting,
              Capital Markets Consulting, Trust Services Consulting, or Expert Witness Services —
              and the right member of our team will respond.
            </p>
          </div>
          <div className="mt-6 p-6 bg-[#0A2B3D] text-white" data-testid="calendly-card">
            <p className="eyebrow text-[#A9CFE2] mb-3">Prefer to Talk?</p>
            <p className="font-serif font-bold text-xl">Schedule a 15-minute call</p>
            <p className="mt-2 text-sm text-white/70 leading-relaxed">
              Skip the form and pick a time that works for you — we'll discuss your needs directly.
            </p>
            <a href={CALENDLY_URL} target="_blank" rel="noreferrer" data-testid="calendly-book-button" className="btn-gold mt-5">
              <CalendarClock size={16} /> Book a Time
            </a>
          </div>
        </Reveal>
        <Reveal className="lg:col-span-7" delay={0.1}>
          <ContactForm />
        </Reveal>
      </div>
    </section>
  </div>
);

export default Contact;
